import { PhoneArrowUpRightIcon } from "@heroicons/react/24/outline";
import { ActivityParentEntityId, isPhoneNumberE164 } from "@sp-crm/core";
import { defaultLinkColour } from "components/ui/link";
import { Panel } from "components/ui/panel/panel";
import { PanelType } from "components/ui/panel/panel-type";
import React from "react";
import { ResponsiveMode } from "store/reducers/responsive";
import { useResponsiveMode } from "store/selectors/hooks";
import { usePhoneLines } from "store/selectors/telecom";
import { phoneUri } from "util/uri";
import { PhoneCall } from "./phone-call";

interface PhoneCallButtonProps {
    value: string;
    entityId?: ActivityParentEntityId;
}

export const PhoneCallButton: React.FC<PhoneCallButtonProps> = props => {
    const { value, entityId } = props;
    const [isPanelOpen, setIsPanelOpen] = React.useState(false);

    const phoneLines = usePhoneLines();

    if (!isPhoneNumberE164(value)) {
        return null;
    }

    if (phoneLines.length === 0) {
        return <PhoneCallButtonWithoutPhoneLine value={value} />;
    }

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        setIsPanelOpen(true);
    };

    const handleDismiss = () => {
        setIsPanelOpen(false);
    };

    return (
        <>
            <div>
                <a href="#" className={defaultLinkColour} onClick={handleClick}>
                    <PhoneArrowUpRightIcon className="w-5 h-5" />
                </a>
            </div>
            <Panel
                isOpen={isPanelOpen}
                onDismiss={handleDismiss}
                type={PanelType.medium}
                headerText="Phone Call"
                hasCloseButton={true}>
                <PhoneCall phoneNumber={value} entityId={entityId} />
            </Panel>
        </>
    );
};

const PhoneCallButtonWithoutPhoneLine: React.FC<PhoneCallButtonProps> = props => {
    const { value } = props;
    const responsiveMode = useResponsiveMode();

    if (responsiveMode >= ResponsiveMode.large) {
        return null;
    }

    const url = phoneUri(value);
    const titleDescription = "Call " + value;
    if (!url || url.length === 0) return null;
    return (
        <div>
            <a
                rel="noopener noreferrer"
                href={url}
                target="_blank"
                title={titleDescription}>
                <PhoneArrowUpRightIcon className="w-5 h-5" />
            </a>
        </div>
    );
};
